import { putPSDetails } from "../services/personalSupportDetails.service";
import { NotificationToaster } from "../utils/notificationToaster";

const updatePSDetails = (clientId, data) => (dispatch, getState) => {
  const { psDetails } = getState().wizard;

  data.criticalClientInformation = !!data.criticalClientInformation
    ? data.criticalClientInformation.trim()
    : "";
  data.personalDetails = !!data.personalDetails
    ? data.personalDetails.trim()
    : "";
  data.supportDetails = !!data.supportDetails ? data.supportDetails.trim() : "";
  data.whatToCareNoteFor = !!data.whatToCareNoteFor
    ? data.whatToCareNoteFor.trim()
    : "";
  const payload = {
    userID: clientId,
    ...data,
  };

  if (
    psDetails?.criticalClientInformation !==
      payload?.criticalClientInformation ||
    psDetails?.personalDetails !== payload?.personalDetails ||
    psDetails?.supportDetails !== payload?.supportDetails ||
    psDetails?.whatToCareNoteFor !== payload?.whatToCareNoteFor
  ) {
    return putPSDetails(payload)
      .then(() => {
        dispatch({ type: "UPDATE_PS_DETAILS", payload: data });
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch({ type: "UPDATE_PS_DETAILS_ERROR", payload: err.message });
        NotificationToaster({ message: "Something went wrong", type: "error" });
      });
  } else {
    return Promise.resolve();
  }
};

export { updatePSDetails };
